import actions from './actions'
import {RequestService as req} from "../../services/requestService";
import { Constants } from "../../config/constants";

const {  fetchDashboardAction, fetchDashboardsAction, fetchDashboardStudentsAction, resetDashboardsFormAction } = actions;


const fetchDashboards = () => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.DASHBOARD}dashboard`,
            auth: 'bearer'
        }, (cb) => dispatch(fetchDashboardsAction(cb)))
    };
};

export const fetchDashboardStudents = (queries, action) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.DASHBOARD}dashboard/students`,
            queries,
            auth: 'bearer'
        },   async (cb) => {
            await dispatch(fetchDashboardStudentsAction(cb))
            if (action) action();
        })
    };
};

export const resetDashboardsForm = () => dispatch => dispatch(resetDashboardsFormAction());


export {fetchDashboards}
